export const EXPIRED_SESSION_FLAG = 'expired_session=show';